export default __webpack_public_path__ + "static/media/ad.0097696c.svg";